/**
 * Processes input changes for a lane object within an array.
 * Extracted from NewEnquiry.onInputChangeHandler().
 * 
 * @param {Array}  lanes - Array of current lane objects.
 * @param {string} label - The field identifier (doc, due, truck, etc.).
 * @param {any}    value - The new value for the field.
 * @param {Object} item  - The specific lane object being modified.
 * @param {number} [index] - The index of the lane object (optional).
 * @returns {Array} Updated array of lane objects.
 */
export const updateLaneField = (lanes, label, value, item, index) => {
  return lanes.map((lane, i) => {
    // Check by reference or index
    if (lane === item || (index !== undefined && i === index)) {
      const updatedLane = {
        ...lane,
        lane_details: { ...lane.lane_details },
      };
      switch (label) {
        case "doc":
          updatedLane.lane_details.document_details = value;
          updatedLane.lane_details.sales_invoice_number = value;
          break;
        case "due":
          updatedLane.lane_details.due_date = value;
          break;
        case "dop_start_time":
          updatedLane.lane_details.dop_start_time = value;
          break;
        case "dop_end_time":
          updatedLane.lane_details.dop_end_time = value;
          break;
        case "truck":
          updatedLane.lane_details.truck_required = value;
          break;
        case "tenure":
          updatedLane.lane_details.contract_tenure = [value];
          break;
        case "truckType":
          updatedLane.lane_details.truck_types = [value];
          break;
      }
      return updatedLane;
    }
    return lane;
  });
};

/**
 * Handles "Select All" logic for approval lists.
 */
export const toggleSelectAllLanes = (allLanes, isChecked) => {
  return isChecked ? [...allLanes] : [];
};

/**
 * Handles individual checkbox toggle for approval lists.
 */
export const toggleLaneSelection = (selectedLanes, lane, isChecked) => {
  if (isChecked) {
    return [...selectedLanes, lane];
  } else {
    return selectedLanes.filter((el) => el.truck_enquiry_id !== lane.truck_enquiry_id);
  }
};

/**
 * Determines if negotiation is disabled for an enquiry item.
 */
export const getNegotiationDisabled = (item, userEmail, isSuperAdmin, spotNegotiation) => {
  if (isSuperAdmin || spotNegotiation) {
    return false;
  }
  if (item.email !== userEmail) {
    return true;
  }
  return false;
};

/**
 * Determines the status of an enquiry (mostly for "approval_pending" check).
 */
export const getEnquiryStatus = (item) => {
  if (item.main_status === "approval_pending") return false;
  const hasApprovedAcceptedRate = item.transporter_list?.some((transporter) =>
    transporter.rate_list?.some(
      (rate) => (rate.main_status === "approved" && rate.bid_status === "accepted") || rate.bid_status === "approved",
    ),
  );
  return !hasApprovedAcceptedRate;
};
